const en = {
  swap: 'Swap',
  markets: 'Markets',
  comingSoon: 'Coming soon',

  header: {
    buyToken: 'Buy Crypto',
    searchTokens: 'Search tokens',
    recentSearches: 'Recent Searches',
    popularTokens: 'Popular Tokens',
    noSearchContent: 'No tokens found.',
    markets: 'Market'
  },

  appSetting: {
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    auto: 'Auto',

    language: 'Language',
    langText: 'English',

    showChart: 'Show Chart',
    contactUs: 'Contact Us',
  },

  stake: {
    know: {
      title: 'Stake TPT Get xTPT',
      desc: 'Stake your TPT to get xTPT, which can be used to vote for the ecology improvement proposals. You can swap your xTPT back to TPT anytime you want.',
    },
    join: 'Staked TPT',
    connectWallet: 'Connect Wallet',
    networkNotvalid: 'Please switch to BSC network',
    approve: 'Approve',
    unstake: 'Unstake',
    add: 'Add',
    loginFirst: '-',
    deposit: 'Deposit TPT',
    withdraw: 'Withdraw TPT',
    balance: 'Balance',
    confirm: 'Confirm',
    overbalance: 'Over available balance',
    success: 'Success',
    all: 'All',
    voteTip: 'Use xTPT to vote for the propopals you support!',
    goVote: 'Go to VOTE',
  },

  fee: {
    desc: "Transit Swap launches the aggregate transaction fee discount function, which according to the discount rate corresponding to the sum of the TPT and xTPT quantity held by the user's account address. There are currently 4 discount levels, and in the future, more levels will be split according to the actual situation.",
    feeDiscount: 'Rate discount',
    walletBalance: 'Balance',
    levelRank: 'Level',
    levelBalance: 'Balance (TPT and xTPT)',
    levelDiscountRate: 'Discount Rate',
  },

  donation: {
    know: {
      title: 'Transit Swap Donation Pool Definition:',
      desc: 'As part of the open blockchain world, the Transit Swap project accepts Token donations from individual users, all donations will go into a donation pool, which will be used for purposes including but not limited to Transit Swap project operations and funding for the Transit Swap related ecosystem.',
    },
    tip: {
      title: 'Important note:',
      desc:
        'The Transit Swap project does not offer definitive rewards to donors; donors who wish to return their donations within 72 hours of the donation hash may do so via the official contact form, but requests for return after this time limit will not be processed.\n' +
        'Types of donation tokens we accept: TPT\n',
    },
    donateType: {
      title: 'Donations accepted address',
      desc: 'TPT',
    },
    address: {
      title: 'Donations accepted address:',
    },
    join: 'Donate',
    donateChain: 'Select a chain',
    connectWallet: '连接钱包',
    donateTip: {
      title: 'Caution:',
      desc: 'Transit Swap does not offer definitive rewards to donors; If you regret to donate, please send the transaction hash to official email within 72 hours to require return.',
    },
    warn: 'Please select a chain first',
    transfer: 'Please use TokenPokcet to scan this QR Code to donate TPT',
    copyAddress: 'Copy address',
    copied: 'Copied',
    yourAddress: 'Your address',
    cantDonate: 'The current chain does not support donations',
    confirmDonate: 'Confirm donation',
    donateSuccess: 'Success',
    donateFail: 'Failed',
    overCount: 'Insufficient balance',
    donateAddress: 'Donation address',
    donateCount: 'Donation Amount (TPT)',
    pleaseSwitch1: 'Please switch to ',
    pleaseSwitch2: ' network',
    downloadTP: 'Cannot donate directly, please download TokenPocket',
    connectTronLink: 'Please connect TronLink first',
    waitBlockConfirm: 'Submitted',
    noZero: 'The donation amount cannot be 0',
  },

  home: {
    title_1: 'With the Power of the Cutting-Edge DEX Platform',
    title_2: 'To Trade Like a PRO',
    swap: 'Swap',
    bridge: 'Bridge',
    startTrading: 'Start Trading',
    viewMore: 'View More',
    modal_contact_us: {
      title: 'Contact Us',
      text_1:
        "* Please be aware that Transit will never contact you first, we won't ask you to charge any fee either.",
    },
    markets: {
      title: 'Markets',
      text: 'Get real-time insights to discover hot tokens and trade smarter with the Market &#128200;&#128201; feature.',
      text_1: 'Coming soon'
    },
    onRamp: {
      title: 'OnRamp',
      text: 'Multiple on/off-ramp channels for optimal token buying and selling.',
    },
    swap_bridge: {
      title: 'Swap & Bridge',
      text: 'Uniting top DEXs, optimizing trades with the best prices and unmatched professionalism on multiple chains. Moreover, we offer professional cross-chain bridge services, ensuring seamless asset liquidity.',
    },
    liquidity_options: {
      title: 'Data',
      text_1: 'Better liquidity,',
      text_2: 'better options',
      Chains: 'Chains',
      DEXs: 'DEXs',
      Bridges: 'Bridges',
      Ramps: 'Ramps',
      Tokens: 'Tokens',
    },
    other_features: {
      title: 'Other features',
      NFT: {
        title: 'NFT',
        text_1: 'NFT Marketplace',
        text_2: 'Transit NFT',
        text_3: 'NFT Design Competition',
      },
      NFT: {
        title: 'Governance',
        text_1: 'DAO',
        text_2: 'Donation',
        text_3: 'Fee',
      },
    },
    get_start: {
      text_1: 'Unlock limitless trading possibilities with Transit',
      text_2: 'To trade like a Pro!',
      text_3: 'Get Started',
    },
  },

  footer: {
    Features: {
      title: 'Features',
      swap: 'Swap',
      bridge: 'Bridge',
      market: 'Market',
      buyCrypto: 'Buy Crypto',
      explorer: 'Explorer',
    },
    NFT: {
      title: 'NFT',
      design: 'Design',
      transitNFT: 'Transit NFT',
      marketplace: 'Marketplace',
    },
    Governance: {
      title: 'Governance',
      dao: 'DAO',
      donation: 'Donation',
      fee: 'Fee',
    },
    Community: {
      title: 'Community',
      developers: 'Developers',
      forum: 'Forum',
      twitter: 'Twitter',
      downloadTP: 'Download TP',
    },
    Help: {
      title: 'Get Help',
      contactUs: 'Contact Us',
      helpCenter: 'Help Center',
    },
  },
};

export default en;
